import { render, staticRenderFns } from "./AddNodeButton.vue?vue&type=template&id=4e804f9c"
import script from "./AddNodeButton.vue?vue&type=script&lang=js"
export * from "./AddNodeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports